export function* map(fn, iterable) {
  for (let x of iterable) yield fn(x);
}

export function* chain(...iterables) {
  for (let x of iterables) yield* x;
}

export function* product(head = [], ...tail) {
  if (tail.length === 0) {
    yield* map(h => [h], head);
  }
  else {
    yield* chain(...map(h => map(t => [h, ...t], product(...tail)), head));
  }
}
